import { render, staticRenderFns } from "./MinTransactionModal.vue?vue&type=template&id=09a50b92"
import script from "./MinTransactionModal.vue?vue&type=script&lang=js"
export * from "./MinTransactionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports